// extracted by mini-css-extract-plugin
export default {"expand":"Layout_expand__DBfG5","menu":"Layout_menu__y158I","custom_text":"Layout_custom_text__oeoXx","full_screen_mobile":"Layout_full_screen_mobile__65v4C"};